






























































































import { Component, Mixins, Watch } from "vue-property-decorator";
import mixins from "@/mixins";
import { Asset } from "@foxone/api/src/models/wallet/mixin";
import currencies from "@/assets/data/currency.json";
import CountrySelect from "../../components/fiat_trade/CountrySelect.vue";
import WyreFiatAmountInput from "../../components/fiat_trade/WyreFiatAmountInput.vue";
import WyreQuotationPanel from "../../components/fiat_trade/WyreQuotationPanel.vue";
import PaymentMethodSelect from "../../components/fiat_trade/PaymentMethodSelect.vue";
import BillAddress from "../../components/fiat_trade/BillAddress.vue";
import TradeStatementModal from "../../components/fiat_trade/TradeStatementModal.vue";
import AddressSelectAction from "trade/components/fiat_trade/AddressSelectAction.vue";
import FAssetSelect from "@foxone/uikit/src/components/FAssetAmountInput/FAssetSelect";
import { CONFIGS, IS_PRODUCT } from "@/constants";

export const defaultAddress = {
  code: "1",
  country: "US"
};

export function getAddress() {
  return JSON.parse(
    localStorage.getItem("wyre-addresses") || JSON.stringify(defaultAddress)
  );
}

export function setAddress(addresses) {
  return localStorage.setItem("wyre-addresses", JSON.stringify(addresses));
}

@Component({
  components: {
    CountrySelect,
    FAssetSelect,
    BillAddress,
    WyreFiatAmountInput,
    WyreQuotationPanel,
    AddressSelectAction,
    PaymentMethodSelect,
    TradeStatementModal
  }
})
class WyrePage extends Mixins(mixins.page) {
  loading = false;

  loadingAsset = false;

  submitting = false;

  requestingQuotation = false;

  quotation: any = null;

  fiatAsset: any = null;

  cryptoAsset: any = null;

  supportCryto: Asset[] = [];

  supportFiat: string[] = [];

  supportCountries: string[] = [];

  address = {
    firstName: "",
    lastName: "",
    street: "",
    city: "",
    postalCode: "",
    state: "",
    email: "",
    phone: "",
    code: 1,
    country: "US"
  };

  form = {
    method: "debit-card",
    dest: "",
    fiatAmount: "",
    cryptoAmount: ""
  };

  get title() {
    return this.$t("trade.cash-in") as string;
  }

  get meta() {
    const isProd = IS_PRODUCT;
    const cryptoAssets = this.supportCryto.map(x => {
      return {
        id: x.asset_id,
        symbol: x.symbol,
        logo: x.icon_url,
        name: x.name
      };
    });
    const fiatAssets = this.supportFiat.map(x => {
      const currency = currencies[x.toUpperCase()];
      return {
        id: x,
        symbol: x,
        unit: currency?.symbol ?? x,
        name: currency?.name ?? "",
        logo: `/country-flags/${currency?.code ?? ""}.svg`
      };
    });
    const destLabel = this.cryptoAsset
      ? `${this.$t("trade.cash-in.dest-label", {
          symbol: this.cryptoAsset.symbol
        })}`
      : this.$t("trade.cash-in.dest-label-default");
    return {
      isProd,
      fiatAssets,
      cryptoAssets,
      destLabel
    };
  }

  get rules() {
    const cryptoAsset = this.cryptoAsset?.symbol ?? "";
    return {
      dest: [
        v =>
          !!v ||
          this.$t("trade.cash-in.dest-address.required", {
            symbol: cryptoAsset.symbol
          })
      ]
    };
  }

  get valid() {
    const fiatAsset = this.fiatAsset?.id;
    const dest = this.form.dest;
    const cryptoAsset = this.cryptoAsset?.id;
    const { country } = this.address;
    return !this.loadingAsset && fiatAsset && dest && country && cryptoAsset;
  }

  get addressCompleted() {
    const {
      firstName,
      lastName,
      street,
      city,
      postalCode,
      state,
      email,
      phone
    } = this.address;
    return (
      firstName &&
      lastName &&
      street &&
      city &&
      postalCode &&
      state &&
      email &&
      phone
    );
  }

  @Watch("fiatAsset")
  @Watch("cryptoAsset")
  @Watch("address.country")
  @Watch("form.fiatAmount")
  handleParamsChange() {
    if (this.valid) {
      this.handleRequestQuotation({});
    }
  }

  @Watch("form.fiatAmount")
  handleFiatAmountChange(value) {
    if (Number(value) <= 0) {
      this.quotation = null;
    } else {
      this.handleRequestQuotation({ from: "fiat" });
    }
  }

  @Watch("form.cryptoAmount")
  handleDestAmountChange(value) {
    if (Number(value) <= 0) {
      this.quotation = null;
    } else {
      this.handleRequestQuotation({ from: "crypto" });
    }
  }

  @Watch("cryptoAsset", { immediate: true })
  async handleCryptoChange() {
    if (!this.cryptoAsset) {
      return;
    }
    const getAssetById = this.$store.getters["wallet/mixin/getAssetById"];
    let asset = getAssetById(this.cryptoAsset?.id);
    if (!asset) {
      this.loadingAsset = true;
      asset = await this.$api.wallet.mixin.getAsset(this.cryptoAsset.id);
      this.loadingAsset = false;
    }
    this.form.dest = asset.destination;
  }

  async mounted() {
    this.init();
    const form = this.$refs.form as any;
    form.validate();
    this.address = getAddress();
  }

  async init() {
    this.loading = true;
    await Promise.all([
      this.requestSupportedCrypto(),
      this.requestSupportedFiat(),
      this.requestSupportedCountry()
    ]);
    this.fiatAsset = this.meta.fiatAssets[0];
    const wanted = this.$route.query.wanted;
    const asset = this.meta.cryptoAssets.find(x => x.id === wanted);
    if (asset) {
      this.cryptoAsset = asset;
    } else {
      this.cryptoAsset = this.meta.cryptoAssets[0];
    }
    this.loading = false;
  }

  handleSubmit() {
    this.requestCreateReservations();
  }

  handleSetDest(dest: string) {
    this.form.dest = dest;
  }

  async requestCreateReservations() {
    this.submitting = true;
    const redirectUrl = `${
      CONFIGS.WEB_HOST
    }/trade/orders?i=2&back=${encodeURIComponent(
      CONFIGS.WEB_HOST + "/wallet"
    )}`;
    try {
      const { url } = await this.$api.market.createWyreReservations({
        dest: this.form.dest,
        source_amount: this.form.fiatAmount,
        source_currency: this.fiatAsset?.id,
        dest_currency: this.cryptoAsset?.symbol,
        country: this.address.country,
        payment_type: this.form.method,
        first_name: this.address.firstName,
        last_name: this.address.lastName,
        phone: `+${this.address.code}${this.address.phone}`,
        email: this.address.email,
        city: this.address.city,
        postal_code: this.address.postalCode,
        street: this.address.street,
        redirect_url: redirectUrl,
        failure_redirect_url: redirectUrl
      });
      window.location.href = url;
    } catch (error) {
      const err = JSON.parse(error?.message ?? "");
      this.$common.utils.helper.errorHandler(this, {
        code: error.code,
        message: err?.message ?? ""
      });
    }
    this.submitting = false;
  }

  handleRequestQuotation = this.$common.utils.helper.debounce(async params => {
    const { fiatAmount, cryptoAmount } = this.form;
    if (this.requestingQuotation) {
      return;
    }
    if (!fiatAmount && !cryptoAmount) {
      return;
    }
    this.requestingQuotation = true;
    await this.requestQuotation(params);
    setTimeout(() => {
      this.requestingQuotation = false;
    }, 210);
  }, 200);

  async requestQuotation(params: { from?: "crypto" | "fiat" }) {
    const { fiatAmount, cryptoAmount } = this.form;
    try {
      const opts: any = {
        source_currency: this.fiatAsset?.id,
        dest_currency: this.cryptoAsset?.symbol,
        dest: this.form.dest,
        country: this.address.country
      };
      if (params.from === "fiat") {
        opts.source_amount = fiatAmount;
      } else if (params.from === "crypto") {
        opts.dest_amount = cryptoAmount;
      } else {
        if (fiatAmount && cryptoAmount) {
          opts.source_amount = fiatAmount;
        } else if (this.form.fiatAmount) {
          opts.source_amount = fiatAmount;
        } else {
          opts.dest_amount = cryptoAmount;
        }
      }
      this.quotation = await this.$api.market.getWyreQuotations(opts);
      if (opts.source_amount) {
        this.form.cryptoAmount = this.quotation.destAmount;
      } else {
        this.form.fiatAmount = this.quotation.sourceAmountWithoutFees;
      }
    } catch (error) {
      this.$common.utils.helper.errorHandler(this, {
        code: error.code,
        message: error?.message ?? ""
      });
    }
  }

  async requestSupportedCrypto() {
    try {
      this.supportCryto = await this.$api.market.getWyreSupportedCrypto();
    } catch (error) {
      this.$common.utils.helper.errorHandler(this, error);
    }
  }

  async requestSupportedFiat() {
    try {
      this.supportFiat = await this.$api.market.getWyreSupportedFiat();
    } catch (error) {
      this.$common.utils.helper.errorHandler(this, error);
    }
  }

  async requestSupportedCountry() {
    try {
      this.supportCountries = await this.$api.market.getWyreSupportedCountry();
    } catch (error) {
      this.$common.utils.helper.errorHandler(this, error);
    }
  }
}
export default WyrePage;
